import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import Icon from "backpack-ui/dist/components/icon";
import styles from "./styles.css";

const LinkIcon = ({ expanded }) => (
  <Icon.ChevronDown
    className={cn(styles.linkIcon, expanded && styles.linkIconExpanded)}
  />
);

LinkIcon.propTypes = {
  expanded: PropTypes.bool,
};

LinkIcon.defaultProps = {
  expanded: false,
};

export default LinkIcon;
